import {DOCUMENT} from '@angular/common';
import {Component, HostListener, Inject, Input, OnInit, ViewChild} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {AbstractComponent, FileType, PanelComponent} from '@components';
import {CategoryItem, CompetitorFilter, CompetitorResults, DEFAULT_PAGE_INDEX, DEFAULT_PAGE_SIZE, EventItem, Lookups, PagedFilter, Pages, Race} from '@model';
import {TranslocoService} from '@ngneat/transloco';
import { ExportService } from '@services';

@Component({
  selector: 'app-race-results-list-component',
  templateUrl: './race-results-list-component.component.html',
  styleUrls: ['./race-results-list-component.component.scss']
})
export class RaceResultsListComponentComponent extends AbstractComponent{
  @Input() race: Race | undefined;
  @Input() genders: Lookups[] = [];
  @Input() results: CompetitorResults[] = []
  @Input() eventItem: EventItem | undefined;
  @Input({required: true}) languages: Lookups[] = [];
  @Input() categories: CategoryItem[] = [];

  @ViewChild("importPanel") importPanel?: PanelComponent;

  showFabButton: boolean = false;
  selectedFile: string | undefined;
  gender: number | undefined = undefined;
  page: number = DEFAULT_PAGE_INDEX;
  name: string | undefined;
  category: number | undefined = undefined;
  hasMore: boolean = false;
  filter: PagedFilter<CompetitorFilter> | undefined;

  constructor(public translocoService: TranslocoService, @Inject(DOCUMENT) private document: Document,private exportService: ExportService,private route: ActivatedRoute) {
    super();
  }
  
  handleFilterChange(filter: PagedFilter<CompetitorFilter>): void {
    this.filter = filter;
  }

  @HostListener('window:scroll')
  toggleFabButton(): void {
    this.showFabButton = window.pageYOffset != 0;
  }

  trackByFn(index: number, item: CompetitorResults): number | undefined {
    return item.id;
  }

  scrollToTop(): void {
    return this.document.body.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
      inline: 'start'
    });
  }

  importResultList() {
    //todo
  }

  initImportParams() {
    //todo
  }


  exportCompetitorResultsList(type: string) {
    if(this.filter === undefined || !this.filter || this.filter ===null){
      let filter: CompetitorFilter = new CompetitorFilter();
      if (this.category) {
        filter.categories = [this.category];
      }
      filter.gender = this.gender ?? undefined;
      filter.name = this.name;
      filter.eventId = +this.route.snapshot.queryParams['eventId'],
      filter.raceId = +this.route.snapshot.queryParams['raceId'];
      this.filter  = new PagedFilter(new Pages(undefined, this.page), filter);
    }
    
    this.exportService.downloadResultsForRaceFile(type, this.filter).subscribe(
      (blob: Blob) => {
        const formattedDateTime = this.getCurrentDateTimeFormatted();
        const filename = type + '_' + formattedDateTime + '.' + type;
        const downloadLink = this.document.createElement('a');
        downloadLink.href = window.URL.createObjectURL(blob);
        downloadLink.setAttribute('download', filename);
        this.document.body.appendChild(downloadLink);
        downloadLink.click();
      },
      error => {
        console.error('Error downloading file:', error);
      }
    );
  }

  getCurrentDateTimeFormatted(): string {
    const currentDateTime = new Date();
    const year = currentDateTime.getFullYear();
    const month = this.padNumber(currentDateTime.getMonth() + 1, 2);
    const day = this.padNumber(currentDateTime.getDate(), 2);
    return `${year}-${month}-${day}`;
  }

  padNumber(num: number, size: number): string {
    let numStr = num.toString();
    while (numStr.length < size) {
      numStr = '0' + numStr;
    }
    return numStr;
  }

  editResult(_: CompetitorResults) {

  }

  deleteResult(_: CompetitorResults) {

  }

  resultsFileAdded(file: string | undefined) {
    this.selectedFile = file;
  }


  onImportPanelCancel() {
    this.selectedFile = undefined;
    this.importPanel?.closeDropdown()
  }

  onImportPanelSave() {
    //todo
  }

  protected readonly FileType = FileType;
}
